import React from "react";
import { useTranslation } from "react-i18next";
import { AccountState } from "@/domains/account/slice";

type Props = {
  sessions: AccountState["activeSessions"];
};

export default function PlayerMenuSettingsSafetyCloseSession({ sessions }: Props) {
  const { t } = useTranslation("account");
  return (
    <div className="flex flex-col gap-5">
      <div className="min-h-[3rem] flex items-center justify-between px-3 border border-dark-800 rounded-[0.5rem]">
        <div className="text-15 font-bold text-white">{t("account.activeSession")}</div>
        <div className="text-15 font-bold text-accent-solid">{sessions.length}</div>
      </div>
      <div className="flex flex-col gap-3.5">
        <div className="text-12 text-white/50 font-bold uppercase">{t("account.sessions")}:</div>
        {sessions.map((item, index) => (
          <React.Fragment key={`${item.location}-${item.ip}`}>
            <div>
              <div className="text-15 text-white font-medium">Windows</div>
              <div className="text-14 text-white/50 font-medium mt-0.5">
                {item.location}, {item.ip}
              </div>
            </div>
            {index !== sessions.length - 1 && <div className="w-full h-[1px] bg-white/40" />}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}
